import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FilterField } from '@features/file-explorer/components/Toolbar/filterTypes'

interface ChoiceFilterInputProps {
  field: FilterField
  onSubmit: (value: string, valueLabel: string) => void
}

export function ChoiceFilterInput({ field, onSubmit }: ChoiceFilterInputProps) {
  const { t } = useTranslation()
  const [filterValue, setFilterValue] = useState('')

  const handleSubmit = () => {
    if (!filterValue || !field.choices) return

    const choice = field.choices.find((c) => c.value === filterValue)
    const valueLabel = choice?.label || filterValue
    onSubmit(filterValue, valueLabel)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  // Special handling for type filter (button group)
  if (field.key === 'type' && field.choices) {
    return (
      <div className="flex gap-2">
        {field.choices.map((choice) => (
          <button
            key={choice.value}
            onClick={() => onSubmit(choice.value, choice.label)}
            className="btn btn-sm btn-soft btn-primary flex-1"
            autoFocus={choice.value === field.choices![0].value}
            data-testid={`filter-value-${choice.value}`}
          >
            {choice.label}
          </button>
        ))}
      </div>
    )
  }

  // Regular select dropdown for other choice fields
  return (
    <>
      <select
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
        onKeyDown={handleKeyDown}
        className="select select-bordered select-sm w-full"
        autoFocus
      >
        <option value="">{t('fileExplorer.filters.selectValue')}</option>
        {field.choices?.map((choice) => (
          <option key={choice.value} value={choice.value}>
            {choice.label}
          </option>
        ))}
      </select>
      <button
        onClick={handleSubmit}
        disabled={!filterValue}
        className="btn btn-primary btn-sm w-full mt-2"
      >
        {t('fileExplorer.filters.addFilter')}
      </button>
    </>
  )
}
